import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { Colors } from 'constants';
import { useTranslation } from 'react-i18next';

const FooterDiv = styled.div`
	ul {
		a {
			padding: 0 10px;
			text-transform: uppercase;
			color: white;

			&:hover, &.active { color: ${Colors.lightblue}; }
		}
	}

	> div:last-child {
		display: flex;
		flex-direction: column;
		gap: 5px;

		a {
			text-decoration: underline;
		}
	}
	
	p {
		color: white !important;

		a {
			color: white !important;
			text-decoration: underline !important;
		}

	}
`;

export const Footer = () => {
	const { t } = useTranslation();
	const currentYear = new Date().getFullYear();

	return (
		<div className='block-fullwidth bg-blue padding-20'>
			<FooterDiv className='col-1 color-white font-16'>

				<ul className='margin-bottom-20 flex row justify-center mobile-hidden'>
					<li><NavLink to='/buyer_integration'>{t('Интеграция с покупателями')}</NavLink></li>
					<li><NavLink to='/hotel_integration'>{t('Интеграция с отелями')}</NavLink></li>
				</ul>

				<div className='line bg-white mobile-hidden' />

				<div className='pt-sans font-16 text-center'>
					<p>© «{t('АОН.РУ')}», {currentYear}</p>
					<p>
						{t('Разработано')} <a href="https://digitaltraveltech.ru/" target="_blank" rel="noreferrer">{t('ООО «ЦТТ»')}</a>
					</p>
				</div>
			</FooterDiv>
		</div>
	);
};
